import React from "react";
import { useLocation } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { CartDrawer } from "@/components/CartDrawer";
import { ShopAIWidget } from "@/components/ShopAIWidget";
import { CookieConsent, getConsent } from "@/components/CookieConsent";
import { api } from "@/lib/api";

function useTraffic() {
  const loc = useLocation();
  React.useEffect(() => {
    const c = getConsent();
    if (c && c.analytics === false) return; // respect cookie consent — no analytics tracking
    let sid = localStorage.getItem("sn_visitor");
    if (!sid) { sid = "v-" + Math.random().toString(36).slice(2) + Date.now().toString(36); localStorage.setItem("sn_visitor", sid); }
    api.post("/track", { path: loc.pathname, session_id: sid }).catch(() => {});
  }, [loc.pathname]);
}

export function Layout({ children }) {
  useTraffic();
  const loc = useLocation();
  const authPage = /^\/(login|register|signup|forgot-password|reset-password|biometric-setup|checkout)/.test(loc.pathname);
  const checkoutPage = loc.pathname.startsWith("/checkout");
  return (
    <div className={`min-h-screen flex flex-col bg-background ${authPage ? "sn-auth-page" : ""} ${checkoutPage ? "sn-checkout-page" : ""}`}>
      <div className="bg-[#111] text-white text-center text-[11px] sm:text-xs font-semibold py-1.5 px-3 flex items-center justify-center gap-1.5" data-testid="powered-by-smart-ai">
        <span className="inline-block h-1.5 w-1.5 rounded-full bg-emerald animate-pulse" /> Powered by Smart AI
      </div>
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      <CartDrawer />
      <ShopAIWidget />
      <CookieConsent />
    </div>
  );
}
